import type { ComponentType } from 'react';
import {
  BookOpenIcon,
  CalendarDaysIcon,
  CogIcon,
  DocumentCheckIcon,
  DocumentTextIcon,
  FolderIcon,
  PaperAirplaneIcon,
  QuestionMarkCircleIcon,
  RectangleStackIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import type { ViewNode } from './graphModel';

type KindIcon = { icon: ComponentType<{ className?: string }>; className: string };

/** The icon of each node kind and its colour, as the canvas cards draw them (see `nodes/`). */
const KIND_ICON: Record<ViewNode['kind'], KindIcon> = {
  engine: { icon: CogIcon, className: 'text-indigo-600 dark:text-indigo-400' },
  aircraft: { icon: PaperAirplaneIcon, className: 'text-sky-600 dark:text-sky-400' },
  part: { icon: WrenchScrewdriverIcon, className: 'text-emerald-600 dark:text-emerald-400' },
  reference: { icon: DocumentCheckIcon, className: 'text-amber-600 dark:text-amber-400' },
  document: { icon: DocumentTextIcon, className: 'text-gray-500 dark:text-zinc-400' },
  event: { icon: CalendarDaysIcon, className: 'text-slate-600 dark:text-slate-400' },
  ipc: { icon: BookOpenIcon, className: 'text-violet-600 dark:text-violet-400' },
  group: { icon: RectangleStackIcon, className: 'text-gray-500 dark:text-zinc-400' },
  project: { icon: FolderIcon, className: 'text-indigo-600 dark:text-indigo-400' },
};

/** A node kind added after this release, as GenericNode draws it. */
const FALLBACK: KindIcon = { icon: QuestionMarkCircleIcon, className: 'text-gray-400 dark:text-zinc-500' };

export const kindIcon = (kind: string): KindIcon => KIND_ICON[kind as ViewNode['kind']] ?? FALLBACK;
